import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Post Regions',
  basePath: '/post-regions',
  columns: [
    { key: 'country_name', label: 'Country', sortable: true },
    { key: 'region', label: 'Region', sortable: true },
    { key: 'delivery_cost', label: 'Delivery Cost', sortable: true },
    { key: 'subscription_delivery_cost', label: 'Subscription Delivery Cost', sortable: true },
  ],
  fields: [
    { key: 'country', label: 'Country', type: 'async-select',
      optionsUrl: '/countries/options', required: true },
    { key: 'region', label: 'Region', type: 'text', required: true },
    { key: 'delivery_cost', label: 'Delivery Cost', type: 'number' },
    { key: 'subscription_delivery_cost', label: 'Subscription Delivery Cost', type: 'number' },
  ],
  defaultSort: { field: 'region', dir: 'asc' },
});
